import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CommonSeach = _resolveComponent("CommonSeach");
  const _component_ProductBtnList = _resolveComponent("ProductBtnList");
  const _component_ProductListCom = _resolveComponent("ProductListCom");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white",
    style: {
      "min-height": "calc( 100% - 80px )"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_CommonSeach, {
      diySerach: $setup.data.diySerach,
      "onUpdate:diySerach": _cache[0] || (_cache[0] = $event => $setup.data.diySerach = $event),
      noticeClear: $setup.data.noticedata,
      "onUpdate:noticeClear": _cache[1] || (_cache[1] = $event => $setup.data.noticedata = $event),
      options: $setup.data.options,
      "onUpdate:options": _cache[2] || (_cache[2] = $event => $setup.data.options = $event),
      onGetSeachData: $setup.getSeachData,
      onGetChangeValue: $setup.getChangeValue,
      onGetSeachTopSeachVal: $setup.getSeachTopSeachVal
    }, null, 8, ["diySerach", "noticeClear", "options", "onGetSeachData", "onGetChangeValue", "onGetSeachTopSeachVal"]), _createVNode(_component_ProductBtnList, {
      onGetClickBtnType: $setup.getClickBtnType
    }, null, 8, ["onGetClickBtnType"]), _createVNode(_component_ProductListCom, {
      prolist: $setup.data.prolist,
      "onUpdate:prolist": _cache[3] || (_cache[3] = $event => $setup.data.prolist = $event),
      getlistSearch: $setup.data.list,
      "onUpdate:getlistSearch": _cache[4] || (_cache[4] = $event => $setup.data.list = $event),
      searchComVal: $setup.data.searchComVal,
      "onUpdate:searchComVal": _cache[5] || (_cache[5] = $event => $setup.data.searchComVal = $event),
      searchChangeVal: $setup.data.searchChangeVal,
      "onUpdate:searchChangeVal": _cache[6] || (_cache[6] = $event => $setup.data.searchChangeVal = $event),
      noticedata: $setup.data.noticedata,
      "onUpdate:noticedata": _cache[7] || (_cache[7] = $event => $setup.data.noticedata = $event),
      onClearParaBtn: $setup.clearParaBtn,
      onGetSizeValue: $setup.getSizeValue,
      onGetPageValue: $setup.getPageValue
    }, null, 8, ["prolist", "getlistSearch", "searchComVal", "searchChangeVal", "noticedata", "onClearParaBtn", "onGetSizeValue", "onGetPageValue"])]),
    _: 1
  });
}